<template>
  <el-select v-model="selectValue" filterable placeholder="请选择"  @change="change" dname="dictName">
    <el-option label="请选择" value=""></el-option>
    <el-option v-for="item in options" :key="item.DictItemID" :label="item.DictItemName" :value="item.DictItemID">
    </el-option>
  </el-select>
</template>

<script>
export default {
  name: 'ZPGLFormDictItemSelect',
  data () {
    return {
      options: [],
      selectValue: this.value
    }
  },
  props: {
    dictid: {
      type: Number
    },
    value: {
      
    },
    dname: {
      type: String
    }
  },
  methods: {
    change: function (selVal) {
      this.$emit('input', selVal)
      let obj = {}
      obj = this.options.find((item)=>{
        return item.DictItemID === selVal
      })
      this.$emit('update:dname', obj.DictItemName)
    }
  },
  watch: {
    value (newVal) {
      this.selectValue = newVal
    }
  },
  mounted: function () {
    this.rolelevel = sessionStorage.getItem('rolelevel')
    this.userid = sessionStorage.getItem('userid')
    var that = this
    var args = {
      token: sessionStorage.getItem('token'),
      dictid: this.dictid,
      rolelevel: this.rolelevel,
      userid: this.userid
    }
    this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIDictItem/DictList', args, function (data) {
      that.options = data.Data
    }, null, null, null)
  }
}
</script>

<style scoped="scoped">
  .el-select {
    width: 100%;
  }
</style>
